"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
exports.getNextData = exports.getNextOrder = exports.sortData = exports.getSortingIcon = exports.DESCENDING = exports.ASCENDING = void 0;
var react_1 = __importDefault(require("react"));
var R = __importStar(require("ramda"));
var ArrowDownIcon_1 = __importDefault(require("mdi-react/ArrowDownIcon"));
var ArrowUpIcon_1 = __importDefault(require("mdi-react/ArrowUpIcon"));
exports.ASCENDING = 'ascending';
exports.DESCENDING = 'descending';
var getSortingIcon = function (sortingOption, currentLabel) {
    var icon = null;
    if (sortingOption.order === exports.ASCENDING) {
        icon = react_1["default"].createElement(ArrowUpIcon_1["default"], null);
    }
    if (sortingOption.order === exports.DESCENDING) {
        icon = react_1["default"].createElement(ArrowDownIcon_1["default"], null);
    }
    if (sortingOption.label !== currentLabel) {
        icon = react_1["default"].createElement(ArrowDownIcon_1["default"], { className: "vs-unsorted-row-icon" });
    }
    return icon;
};
exports.getSortingIcon = getSortingIcon;
var ascend = R.curry(function ascend(fn, value, consecutiveValue) {
    var valueClone = fn(value);
    var consecutiveValueClone = fn(consecutiveValue);
    return valueClone === null ? -1 : consecutiveValueClone === null ? 1 : valueClone < consecutiveValueClone ? -1 : valueClone > consecutiveValueClone ? 1 : 0;
});
var descend = R.curry(function descend(fn, value, consecutiveValue) {
    var valueClone = fn(value);
    var consecutiveValueClone = fn(consecutiveValue);
    return valueClone === null ? 1 : consecutiveValueClone === null ? -1 : valueClone > consecutiveValueClone ? -1 : valueClone < consecutiveValueClone ? 1 : 0;
});
var sort = function (order) { return function (index, data) {
    return R.sortWith([order(R.path(['row', index]))])(data);
}; };
var sortAscendingByIndex = sort(ascend);
var sortDescendingByIndex = sort(descend);
var sortingFunctionMap = (_a = {},
    _a[exports.ASCENDING] = sortAscendingByIndex,
    _a[exports.DESCENDING] = sortDescendingByIndex,
    _a);
var sortData = function (index, order, data) {
    return sortingFunctionMap[order](index, data);
};
exports.sortData = sortData;
var getNextOrder = function (order) {
    if (!order || order === exports.ASCENDING)
        return exports.DESCENDING;
    if (order === exports.DESCENDING)
        return exports.ASCENDING;
};
exports.getNextOrder = getNextOrder;
var getNextData = function (index, currentOrder, data) {
    return (0, exports.sortData)(index, (0, exports.getNextOrder)(currentOrder), data);
};
exports.getNextData = getNextData;
